(ns practitest.frontend.summary.main
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.summary.events :as events]
            [practitest.frontend.summary.views :as views]))

(defn index-view []
  [views/page])

(defn page-controller []
  {:start (fn [_]
            (let [tab-id (.get (js/URLSearchParams. (.-search js/window.location)) "id")]
              (re-frame/dispatch [::events/fetch tab-id])))
   :stop  (fn [_] (re-frame/dispatch [::events/reset]))})
